import React, { useMemo,useEffect, useState} from 'react';
import './reservas.css';
import axios from 'axios';
import Logoicono from '../Componentes/logosvg2';
import DatePicker from 'react-datepicker';
import { useTable, useFilters, useSortBy } from "react-table";
import * as XLSX from 'xlsx'; 
import { json } from 'react-router-dom';
import {toast, Toaster} from 'react-hot-toast';




function Reservas() {
  const [reservasObtenidas, setReservasObtenidas] = useState([]);
  const [timer, setTimer] = useState(true);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  async function Cargar() {
    const datoscargados = await getReservas();
    if (datoscargados) {
      console.log('Informacion cargada');
      setReservasObtenidas(datoscargados);
      setTimer(false);
    }
  }
  function getReservas(){
    return new Promise(resolve => {
      axios.get(`${process.env.REACT_APP_HTTPS}/api/establecimientos/allreservas`)
        .then((response) => {
          resolve (response.data);
        })
        .catch((error) => {
          console.error('Error al obtener las Reservas:', error);
        });
    })
};

  useEffect(() => {
    Cargar();
  }, []); 

  const filteredReservas = useMemo(() => {
    if (!startDate || !endDate) return reservasObtenidas;
    
    return reservasObtenidas.filter(reserva => {
      const [day, month, year] = reserva.dia.split('/'); 
      const reservaDate = new Date(`${year}-${month}-${day}`); 
      return reservaDate >= startDate && reservaDate <= endDate;
    });
  }, [startDate, endDate, reservasObtenidas]);

  const columns = useMemo(
    () => [
      {Header: "ID", accessor: "id_reserva"},
      { Header: "Día", accessor: "dia" ,
        sortType: (rowA, rowB, columnId) => {
          const parseDate = (dateStr) => {
            const [day, month, year] = dateStr.split('/');
            return new Date(`${year}-${month}-${day}`);
          };
          
          const dateA = parseDate(rowA.values[columnId]);
          const dateB = parseDate(rowB.values[columnId]);
          
          return dateA - dateB; 
        },
      },
      { Header: "Hora", accessor: "hora" },
      { Header: "Tipo", accessor: "tipo_cancha" },
      { Header: "Medio", accessor: "Medio" },
      { Header: "Estado", accessor: "estado" },
      { Header: "Comentario", accessor: "Descripcion"},
      { Header: "Cliente", accessor: "Nombre_cliente" },
      { Header: "Correo", accessor: "correo" },
      { Header: "Contacto", accessor: "contacto" },
      { Header: "Deposito", accessor: "pagado"},
      { Header: "Precio", accessor: "precio"},
    ],
    []
  );

  const [sortColumn, setSortColumn] = useState("rowNumber");
  const [sortOrder, setSortOrder] = useState("desc");
  
 const tableInstance = useTable(
    {
      columns: columns || [], data: filteredReservas || [],
      initialState: {
        sortBy: [
          {
            id: sortColumn,
            desc: sortOrder === "desc",
          },
        ],
      },
    },
    useFilters,
    useSortBy
  );

const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
    } = 
    tableInstance;

    useEffect(() => {
      tableInstance.setSortBy([{ id: sortColumn, desc: sortOrder === "desc" }]);
    }, [sortColumn, sortOrder, tableInstance]);

const getUniqueValues = (data, columnId) => {
  return [...new Set(data.map(item => item[columnId]))];
};

const exportToExcel = async () => {
  if (!startDate){
    if(!endDate){
      toast.error("Selecciona fecha de consulta")
      return
    }
    toast.error("Selecciona fecha de consulta")
    return
  }
  else {if (!endDate){ toast.error("Selecciona fecha de consulta"); return} }
  await axios.post(`${process.env.REACT_APP_HTTPS}/api/reservas/allprint`, {Fechini: startDate, Fechfin: endDate})
    .then((response) => {
      const datosexc = (response.data);
      const ws = XLSX.utils.json_to_sheet(datosexc);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Reservas");
      const today = new Date();
      const dateStr = today.toISOString().split('T')[0];
      XLSX.writeFile(wb, `Chamuscon_reservas_${dateStr}.xlsx`);
    })
    .catch((error) => {
      console.error('Error al obtener las Reservas:', error);
    });
};

  return (<>
  <div className='todores'>
  <div className='tituloreservas'><h1 className='titreservas'>Todas las reservas</h1>
  {timer ? (<div className='cargando'>
              <div className='logocargando'><Logoicono/></div>
            </div>):(<></>)}
  <div className='filtrosreserva'>
    <label>
        Ordenar por:
        <select
          value={sortColumn}
          onChange={(e) => setSortColumn(e.target.value)}
        >
          {columns.map((col) => (
            <option key={col.accessor} value={col.accessor}>
              {col.Header}
            </option>
          ))}
        </select>
    </label>
    <label>
      Orden:
      <select
        value={sortOrder}
        onChange={(e) => setSortOrder(e.target.value)}
      >
        <option value="asc">Ascendente</option>
        <option value="desc">Descendente</option>
      </select>
    </label>
    <br/>
    <label>Desde: 
      <DatePicker selected={startDate} onChange={date => setStartDate(date)} />
    </label>
    <label>Hasta:
      <DatePicker selected={endDate} onChange={date => setEndDate(date)} />
    </label>
    <button onClick={() => { setStartDate(null); setEndDate(null); tableInstance.setAllFilters([]);}}>
      Resetear
    </button>
    
  </div>
  <button onClick={exportToExcel} className='export_excel'>
      Exportar a Excel
  </button>
  </div>
    <div className='fondo'>
      <table {...getTableProps()} className='allreservas'>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            <th>No.</th>
            {headerGroup.headers.map(column => (<>
              <th {...column.getHeaderProps()} style={{ borderBottom: "1px solid black", padding: "8px" }}>
                {column.render("Header")}
                <div>
                  {/* Componente select para filtrado */}
                  <select
                    onChange={e => column.setFilter(e.target.value || undefined)}
                    style={{ marginTop: "5px", maxWidth: "300px" }}>
                    <option value="" style={{ marginTop: "5px", maxWidth: "100px" }}>Todas</option>
                    {getUniqueValues(reservasObtenidas, column.id).map(optionValue => (
                      <option key={optionValue} value={optionValue}>
                        {optionValue}
                      </option>
                    ))}
                  </select>
                </div>
              </th>
            </>))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, index) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              <td style={{
                backgroundColor: '#ffffff',
                fontWeight: 'normal',
                color: 'black',
                border: '2px black solid',
                padding: '5px 10px',
                textAlign: 'center',
                maxWidth: "500px",
                whiteSpace: "normal",
              }}>
                {index + 1}
              </td>
              {row.cells.map(cell => (
                <td  style={{
                  backgroundColor: '#ffffff',
                  fontweight: 'normal',
                  color: 'black',
                  border: '2px black solid',
                  padding: '5px 10px',
                  textalign: 'center',
                  maxWidth:"500px",
                  whiteSpace: "normal",
                }}>
                  {cell.render("Cell")}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
    </div>
    </div><Toaster /></>
  );
}

export default Reservas;
